
document.addEventListener('teeinblue-event-component-injected', function() {
  // Zeige das Element mit der ID 'elementToShow'
  var elementToShow = document.getElementById('headerp');
  elementToShow.style.display = 'block';
});

document.addEventListener('DOMContentLoaded', function() {
  // Verstecke das Element mit der ID 'elementToHide'
  var elementToHide = document.getElementById('headerp');
  elementToHide.style.display = 'none';
});

document.addEventListener('teeinblue-event-component-injected', function() {
  // Verstecke das Element mit der ID 'elementToHide'
  var elementToHide = document.getElementById('AddToCart');
  elementToHide.style.display = 'none';
});

document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('#custom-ddd');
  const insertAfterElement = document.querySelector('.tee-product-price');
  elementToMove.style.display = "block"
  if (elementToMove && insertAfterElement) {        
   insertAfterElement.after(elementToMove)
  } 
});

document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('#bulletd');
  const insertAfterElement = document.querySelector('#custom-ddd');
  elementToMove.style.display = "block"
  if (elementToMove && insertAfterElement) {        
   insertAfterElement.after(elementToMove)
  } 
});

document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('#beliebt');
  const insertAfterElement = document.querySelector('#bulletd');
  elementToMove.style.display = "block"
  if (elementToMove && insertAfterElement) {        
   insertAfterElement.after(elementToMove)
  } 
});

document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('#headerp');
  const insertAfterElement = document.querySelector('.tee-block.tee-variants');
  elementToMove.style.display = "block"
  if (elementToMove && insertAfterElement) {        
   insertAfterElement.after(elementToMove)
  } 
});


document.addEventListener('teeinblue-event-after-cart-added', function() {
  fetch(`${window.themeVariables.routes.cartUrl}.js`)
    .then(res => res.json())
    .then(cartData => {
    fetch(window.location.pathname + "?sections=mini-cart")
      .then(res => res.json())
      .then(cartContent => {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        detail: {
          cart: {...cartContent, ...cartData}
        }
      }));
    })
  })
  const triggerElement = document.querySelector('a[aria-controls="mini-cart"]');
  if(triggerElement) {
    triggerElement.click();
  }
});